module.exports = __webpack_public_path__ + "img/Menu-04.beb5a8e5.png";